import { ACHAT } from '@/configuration/parametrage/schemaComptableConf';

export default function genererSchemaComptable() {
  return {
    libelle: null,
    type: ACHAT,
    libelleEcriture: null,
    libelleLigneEcritureTiers: null,
    libelleLigneEcritureTva: null,
    libelleLigneEcritureContrepartie: null,
    actif: true,
    compteNormal: null,
    compteExport: null,
    compteTva: null,
    compteTvaEncaissement: null,
    compteConstateDavance: null,
    compteRemiseGeneral: null,
    compteRemiseRegie: null,
    tvaSurEncaissement: false,
  };
}
